class CookieHelper {
    static get(name) {
        name += "=";
        let ca = document.cookie.split(";");
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
        }
        return null;
    }

    static set(name, value, expiresDays = null) {
        let expires = "";

        if (expiresDays !== null) {
            let d = new Date();
            d.setTime(d.getTime() + (expiresDays * 24 * 60 * 60 * 1000));
            expires = "expires=" + d.toUTCString();
        }

        document.cookie = name + "=" + value + "; path=/; " + expires;
    }
}

export default CookieHelper;